import * as server from "@/utils/http"

export const _page = params => server.get("/inspect-organize/page", params);

export const _inspectOrganizeList = params => server.get("/inspect-organize/list", params);

export const _get = params => server.get("/inspect-organize/get", params);

export const _save = params => server.post(params.id ? "/inspect-organize/update" : "/inspect-organize/save", params);

export const _updateStatus = params => server.get("/inspect-organize/updateStatus", params);
